import { z } from 'zod';

export const PlaceCategoryGroupEnum = z.enum(['FOOD', 'LEISURE', 'SPORT', 'NATURE', 'SERVICE']);
export type PlaceCategoryGroup = z.infer<typeof PlaceCategoryGroupEnum>;

export const PlaceCategoryDto = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  icon: z.string().nullable(),
  group: PlaceCategoryGroupEnum.nullable(),
  sortOrder: z.number().int(),
  isActive: z.boolean(),
  googleTypes: z.array(z.string()).optional(),
});
export type PlaceCategoryDto = z.infer<typeof PlaceCategoryDto>;

// Base field validators без .default() — общие для create и update. Дефолты
// живут только на create-инпуте: на partial-update они бы «воскрешали» значения
// (например, googleTypes → []), молча стирая существующие значения при PATCH без этого поля.
const baseShape = {
  slug: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z][a-z0-9-]*$/, 'lowercase, digits, dashes'),
  name: z.string().min(1).max(120),
  icon: z.string().max(8).optional(),
  group: PlaceCategoryGroupEnum.optional(),
  sortOrder: z.number().int().min(0).max(10_000),
  isActive: z.boolean(),
  googleTypes: z.array(z.string()),
} as const;

export const PlaceCategoryCreateInput = z.object({
  ...baseShape,
  sortOrder: baseShape.sortOrder.default(0),
  isActive: baseShape.isActive.default(true),
  googleTypes: baseShape.googleTypes.default([]),
});
export type PlaceCategoryCreateInput = z.infer<typeof PlaceCategoryCreateInput>;

// Partial без дефолтов: опущенное поле остаётся undefined, и сервис его не трогает.
export const PlaceCategoryUpdateInput = z.object(baseShape).partial();
export type PlaceCategoryUpdateInput = z.infer<typeof PlaceCategoryUpdateInput>;
